import { BaseService } from "mrb/core";
import { ProducerAnalyticsApiRouteService } from "common/services";

class ProducerAnalyticsService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProducerAnalyticsApiRouteService());
    }

    findProducerReportPayoutUserEvents(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportPayoutUserEvents(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReports(filter, abortSignal = null) {
        const url = this.routeService.findProducerReports(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerPaymentSummary(filter, abortSignal = null) {
        const url = this.routeService.findProducerPaymentSummary(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerPaymentSummary(producerId, options, abortSignal = null) {
        const url = this.routeService.getProducerPaymentSummary(producerId, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerMostPopularContent(producerId, options, abortSignal = null) {
        const url = this.routeService.getProducerMostPopularContent(producerId, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerSummary(producerId, abortSignal = null) {
        const url = this.routeService.getProducerSummary(producerId);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportTrackItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportTrackItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportContentItems(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportContentItems(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    findProducerReportTrackListeners(filter, abortSignal = null) {
        const url = this.routeService.findProducerReportTrackListeners(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getProducerReportTrackItemsCsv(filter, producerId, abortSignal = null) {
        const url = this.routeService.getProducerReportTrackItemsCsv(filter, producerId);
        return this.apiClient.get(url, { responseType: "blob" }, abortSignal);
    }
}

export default ProducerAnalyticsService;
